/*
 * @Author: 123 1578458020@qq.com
 * @Date: 2022-07-25 15:39:47
 * @LastEditors: 123 1578458020@qq.com
 * @LastEditTime: 2023-01-13 09:02:54
 * @FilePath: \bluesky\bsr-pc\src\config.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const config = {
  //存心救援测试
  // serverUrl: 'https://tp.blueskyrescue.cn/CunXin/index.php/Web',
  // imgUrl: 'https://tp.blueskyrescue.cn/CunXin',
  // imgUrlType2: 'https://benzhiapi.rescueskills.cn',
  // imgUrlType3: 'https://baiketest.rescueskills.cn',

  //存心救援正式
  serverUrl: 'https://api.cunxinrescue.cn/index.php/Web',
  imgUrl: 'https://api.cunxinrescue.cn',
  imgUrlType2: 'https://benzhiapi.rescueskills.cn',
  imgUrlType3: 'https://baikeapi.rescueskills.cn',
  
  debug: false,
  mall_isDo:true,
  mall_isDo2:true,

  shareDoman: 'https://app.blueskyrescue.cn/index.html?test=1&id=',
  reportDoman: 'https://app.blueskyrescue.cn/report.html?test=1&time=',
  sharePlayerDoman: 'https://app.blueskyrescue.cn/player.html?test=1&indexno=',
  insurePay: 'https://app.blueskyrescue.cn/insure_result.html?test=1'
};

config.logo70 = config.imgUrl + '/Uploads/logo70.png';

if (config.imgUrl === 'https://api.blueskyrescue.cn') {
  config.shareDoman = 'https://app.blueskyrescue.cn/index.html?id=';
  config.reportDoman = 'https://app.blueskyrescue.cn/report.html?time=';
  config.sharePlayerDoman = 'https://app.blueskyrescue.cn/player.html?indexno=';
  config.insurePay = 'https://app.blueskyrescue.cn/insure_result.html?test=';
}

export default config;



// WEBPACK FOOTER //
// ./src/config.jsx